var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c("div", { staticClass: "clearfix" }, [
            _c(
              "div",
              { staticClass: "container" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      inline: true,
                      size: "small",
                      "label-width": "120px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "时间选择：" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            staticClass: "mr20",
                            attrs: { type: "button", size: "small" },
                            on: {
                              change: function ($event) {
                                return _vm.selectChange(
                                  _vm.queryParams.dateLimit
                                )
                              },
                            },
                            model: {
                              value: _vm.queryParams.dateLimit,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "dateLimit", $$v)
                              },
                              expression: "queryParams.dateLimit",
                            },
                          },
                          _vm._l(_vm.fromList.fromTxt, function (item, i) {
                            return _c(
                              "el-radio-button",
                              { key: i, attrs: { label: item.val } },
                              [_vm._v(_vm._s(item.text))]
                            )
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c("el-date-picker", {
                          staticStyle: { width: "220px" },
                          attrs: {
                            "value-format": "yyyy-MM-dd",
                            format: "yyyy-MM-dd",
                            size: "small",
                            type: "daterange",
                            placement: "bottom-end",
                            placeholder: "自定义时间",
                          },
                          on: { change: _vm.onchangeTime },
                          model: {
                            value: _vm.timeVal,
                            callback: function ($$v) {
                              _vm.timeVal = $$v
                            },
                            expression: "timeVal",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "订单状态：" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "selWidth",
                            attrs: {
                              clearable: "",
                              placeholder: "请选择订单状态",
                            },
                            model: {
                              value: _vm.queryParams.orderStatus,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "orderStatus", $$v)
                              },
                              expression: "queryParams.orderStatus",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "未处理", value: "0" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "已下单", value: "1" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "已发货", value: "2" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "处理失败", value: "3" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "批次号" } },
                      [
                        _c("el-input", {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请输入批次号",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.queryParams.batchNo,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "batchNo",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "queryParams.batchNo",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "订单号：" } },
                      [
                        _c("el-input", {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请输入订单号",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.queryParams.orderNo,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "orderNo",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "queryParams.orderNo",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "收件人姓名：" } },
                      [
                        _c("el-input", {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请输入收件人姓名",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.queryParams.recipientName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "recipientName",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "queryParams.recipientName",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "收件人手机号：" } },
                      [
                        _c("el-input", {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请输入收件人手机号",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.queryParams.recipientPhone,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "recipientPhone",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "queryParams.recipientPhone",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: { click: _vm.seachList },
                          },
                          [_vm._v("搜索")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.handleImport },
            },
            [_vm._v("导入")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.handleBulkOrder },
            },
            [_vm._v("批量下单")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "mini",
                disabled: _vm.multipleSelection.length == 0,
              },
              on: { click: _vm.handleDelBatch },
            },
            [_vm._v("批量删除")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.refreshLoading,
                  expression: "refreshLoading",
                },
              ],
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.handleRefresh },
            },
            [_vm._v("刷新订单状态")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.handleExport },
            },
            [_vm._v("导出")]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "ql-table mt-20",
              attrs: {
                data: _vm.tableData.data,
                border: true,
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
                "row-key": "orderNo",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _vm._v(" "),
              _vm.checkedCities.includes("批次号")
                ? _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "batchNo",
                      label: "批次号",
                      "min-width": "150",
                      "show-overflow-tooltip": true,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkedCities.includes("商品规格编码")
                ? _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "skuId",
                      label: "商品规格编码",
                      "min-width": "180",
                      "show-overflow-tooltip": true,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkedCities.includes("商品规格名称")
                ? _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "skuName",
                      label: "商品规格名称",
                      "min-width": "180",
                      "show-overflow-tooltip": true,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkedCities.includes("商品名称")
                ? _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "productName",
                      label: "商品名称",
                      "min-width": "180",
                      "show-overflow-tooltip": true,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkedCities.includes("订单状态")
                ? _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "订单状态",
                      "min-width": "150",
                      "show-overflow-tooltip": true,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    scope.row.orderStatus == 0
                                      ? "未处理"
                                      : scope.row.orderStatus == 1
                                      ? "已下单"
                                      : scope.row.orderStatus == 2
                                      ? "已发货"
                                      : scope.row.orderStatus == 3
                                      ? "处理失败"
                                      : ""
                                  ) +
                                  "\n        "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1139245419
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkedCities.includes("订单号")
                ? _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "orderNo",
                      label: "订单号",
                      "min-width": "210",
                      "show-overflow-tooltip": true,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkedCities.includes("下单数量")
                ? _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "num",
                      label: "下单数量",
                      "min-width": "110",
                      "show-overflow-tooltip": true,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkedCities.includes("下单时间")
                ? _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "orderDate",
                      label: "下单时间",
                      "min-width": "170",
                      "show-overflow-tooltip": true,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkedCities.includes("运单号")
                ? _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "waybillNo",
                      label: "运单号",
                      "min-width": "150",
                      "show-overflow-tooltip": true,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkedCities.includes("快递公司")
                ? _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "expressCompany",
                      label: "快递公司",
                      "min-width": "150",
                      "show-overflow-tooltip": true,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkedCities.includes("收件人姓名")
                ? _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "recipientName",
                      label: "收件人姓名",
                      "min-width": "150",
                      "show-overflow-tooltip": true,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkedCities.includes("收件人手机号")
                ? _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "recipientPhone",
                      label: "收件人手机号",
                      "min-width": "150",
                      "show-overflow-tooltip": true,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkedCities.includes("收件人地址")
                ? _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "收件人地址",
                      "min-width": "260",
                      "show-overflow-tooltip": true,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(scope.row.recipientProvince) +
                                  _vm._s(scope.row.recipientCity) +
                                  _vm._s(scope.row.recipientArea) +
                                  _vm._s(scope.row.recipientStreet) +
                                  _vm._s(scope.row.recipientAddress) +
                                  "\n        "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3218219611
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkedCities.includes("失败原因")
                ? _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "failedReason",
                      label: "失败原因",
                      "min-width": "280",
                      "show-overflow-tooltip": true,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "150",
                  fixed: "right",
                  align: "center",
                  "render-header": _vm.renderHeader,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        [0, 3].indexOf(scope.row.orderStatus) !== -1
                          ? _c(
                              "el-button",
                              {
                                staticClass: "mr10",
                                attrs: { type: "text", size: "small" },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.handleEdit(scope.row)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        [0, 3].indexOf(scope.row.orderStatus) !== -1
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "text",
                                  size: "mini",
                                  loading: _vm.orderLoading,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleOrder(scope.row)
                                  },
                                },
                              },
                              [_vm._v("下单")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [20, 40, 60, 80],
                  "page-size": _vm.queryParams.limit,
                  "current-page": _vm.queryParams.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.card_select_show,
              expression: "card_select_show",
            },
          ],
          staticClass: "card_abs",
        },
        [
          [
            _c(
              "div",
              { staticClass: "cell_ht" },
              [
                _c(
                  "el-checkbox",
                  {
                    attrs: { indeterminate: _vm.isIndeterminate },
                    on: { change: _vm.handleCheckAllChange },
                    model: {
                      value: _vm.checkAll,
                      callback: function ($$v) {
                        _vm.checkAll = $$v
                      },
                      expression: "checkAll",
                    },
                  },
                  [_vm._v("全选")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.checkSave()
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-checkbox-group",
              {
                on: { change: _vm.handleCheckedCitiesChange },
                model: {
                  value: _vm.checkedCities,
                  callback: function ($$v) {
                    _vm.checkedCities = $$v
                  },
                  expression: "checkedCities",
                },
              },
              _vm._l(_vm.columnData, function (item) {
                return _c(
                  "el-checkbox",
                  {
                    key: item,
                    staticClass: "check_cell",
                    attrs: { label: item },
                  },
                  [_vm._v(_vm._s(item))]
                )
              }),
              1
            ),
          ],
        ],
        2
      ),
      _vm._v(" "),
      _c("edit-from", { ref: "editRef", on: { success: _vm.getList } }),
      _vm._v(" "),
      _c("import-form", { ref: "importRef", on: { success: _vm.getList } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }